var copyObject = require('./_copyObject'),
    getSymbolsIn = require('./_getSymbolsIn');

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_copySymbolsIn.js
 ** module id = ./node_modules/lodash/_copySymbolsIn.js
 ** module chunks = 0
 **/